import { render, staticRenderFns } from "./shjRedCashout.vue?vue&type=template&id=124215da&scoped=true"
import script from "./shjRedCashout.vue?vue&type=script&lang=js"
export * from "./shjRedCashout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124215da",
  null
  
)

export default component.exports